export const PRODUCT = {
    GET_PRODUCT: "product/GET_PRODUCT",
    GET_PRODUCTS: "product/GET_PRODUCTS",
    GET_PRODUCT_DISCOUNT: "product/GET_PRODUCT_DISCOUNT",
};
